<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75 mb-0">APPLICATION</h1>
          <h2>Real Estate Errors & Omissions Insurance</h2>
        </article>
        <article class="input-section form-section" style="padding-right: 56px;">
          <div style="border: 2px solid black;" class="p-2">
            <p class="text-uppercase mb-1">
              <strong>notice:</strong> this insurance is written on a claims made and reported basis and only applies to claims first made against the certificate holder and reported in writing to the company during the certificate period.
              no coverage exists for claims first made against the certificate holder after the end of the certificate period unless, and to the extent, a basic or extended reporting period applies.
            </p>
            <p class="text-uppercase">
              <strong>notice:</strong> defense expenses are included within and reduce the applicable limit of liability stated in the certificate. please read the entire policy carefully.
            </p>
            <p class="mt-4 mb-1">
              Please answer all questions, and verify that all information is true and complete to the best of your knowledge.
              The application is a warranty to the policy.
            </p>
          </div>
        </article>
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 1: APPLICANT INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name of Applicant / Business Name:
          </label>
          <input
            type="text"
            name="nameOfApplicant"
            v-model="groupAppraiser.nameOfApplicant"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfApplicant')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Name of Primary Licensed/Certified Professional:
          </label>
          <input
            type="text"
            name="nameOfPrimaryLicensed"
            v-model="groupAppraiser.nameOfPrimaryLicensed"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfPrimaryLicensed')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfPrimaryLicensed') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section pb-3">
            <label for class="orep-label mb-0">
              Principal Street Address:
            </label>
            <input
              type="text"
              name="address"
              v-model="groupAppraiser.customer.address"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('address')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('address') | filterText }}</span>
          </div>
          <div class="pt-0 input-section" style="padding-right: 56px;">
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="groupAppraiser.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px;"
                  name="state"
                  v-model="groupAppraiser.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Zip Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="groupAppraiser.customer.zipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3 pt-4">
              <div class="col-md-9">
                <label for class="orep-label mb-0">
                  Mailing Address:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="groupAppraiser.mailingAddress"
                  class="orep-text-input">
                  <!--v-validate="'required'"-->
                  <!--@input="validateBeforeSubmit()"-->
                <!--<span-->
                  <!--v-show="errors.has('address')"-->
                  <!--class="help is-danger form-errors text-danger"-->
                <!--&gt;{{ errors.first('address') | filterText }}</span>-->
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="groupAppraiser.mailingCity"
                  class="orep-text-input w-100">
                  <!--v-validate="'required'"-->
                  <!--@input="validateBeforeSubmit()"-->
                <!--<span-->
                  <!--v-show="errors.has('city')"-->
                  <!--class="help is-danger form-errors text-danger"-->
                <!--&gt;{{ errors.first('city') | filterText }}</span>-->
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px;"
                  name="state"
                  v-model="groupAppraiser.mailingState">
                  <!--v-validate="'required'"-->
                  <!--@change="validateBeforeSubmit()"-->
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <!--<span-->
                  <!--v-show="errors.has('state')"-->
                  <!--class="help is-danger form-errors text-danger"-->
                <!--&gt;{{ errors.first('state') | filterText }}</span>-->
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Zip Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="groupAppraiser.mailingZipCode"
                  class="orep-text-input w-100">
                  <!--v-validate="'required'"-->
                  <!--@input="validateBeforeSubmit()"-->
                <!--<span-->
                  <!--v-show="errors.has('zipCode')"-->
                  <!--class="help is-danger form-errors text-danger"-->
                <!--&gt;{{ errors.first('zipCode') | filterText }}</span>-->
              </div>
            </div>
            <div class="row pb-3 pt-4">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Email:
                </label>
                <input
                  type="email"
                  name="email"
                  autocomplete="email"
                  v-model="groupAppraiser.customer.email"
                  class="orep-text-input w-100"
                  v-validate="'required|email'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('email')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Telephone
                </label>
                <input
                  type="text"
                  name="phone"
                  v-model="groupAppraiser.customer.phone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                  type="text"
                  name="website"
                  v-model="groupAppraiser.customer.fax"
                  class="orep-text-input w-100"
                >
              </div>
            </div>
            <div class="row align-items-center mx-1 pb-0 pt-3">
              <label for class="orep-label mb-0">Applicant Ownership: </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="soleProprietor"
                    value="soleProprietor"
                    class="orep-radio"
                    v-validate="'required|included:soleProprietor,llc,partnership,corporation'"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.applicantOwnership"
                  >
                  <span class="radio-span">Sole Proprietor</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="llc"
                    value="llc"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.applicantOwnership"
                  >
                  <span class="radio-span">LLC</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="partnership"
                    value="partnership"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.applicantOwnership"
                  >
                  <span class="radio-span">Partnership</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="corporation"
                    value="corporation"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.applicantOwnership"
                  >
                  <span class="radio-span">Corporation</span>
                </label>
              </div>
              <span
                v-show="errors.has('soleProprietor')"
                class="help is-danger form-errors text-danger mt-0 mb-2"
              >{{ errors.first('soleProprietor') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">2.</span>Date firm was established:
          </label>
          <input
            type="text"
            name="dateFirmEstablished"
            v-model="groupAppraiser.dateFirmEstablished"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('dateFirmEstablished')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('dateFirmEstablished') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">3.</span>Year current owner assumed management:
          </label>
          <input
            type="text"
            name="yearOfOwnerAssumedManagement"
            v-model="groupAppraiser.yearOfOwnerAssumedManagement"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('yearOfOwnerAssumedManagement')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('yearOfOwnerAssumedManagement') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">4.</span>Number of years owner licensed
          </label>
          <div class="row" style="margin-right: 56px;">
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As an appraiser:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsAppraiser"
                v-model="groupAppraiser.yearOfOwnerLicensedAsAppraiser"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsAppraiser')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsAppraiser') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As an agent:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsAgent"
                v-model="groupAppraiser.yearOfOwnerLicensedAsAgent"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsAgent')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsAgent') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As a broker:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsBroker"
                v-model="groupAppraiser.yearOfOwnerLicensedAsBroker"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsBroker')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsBroker') | filterText }}</span>
            </div>
          </div>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 2: STAFF</h1>
          <h4 class="text-center w-75">
            Professionals are defined as: Owners, Partners, Officers, Appraisers, Real Estate
Brokers/Agents/Salespersons, Property Managers, OR Consultants, including independent contractors.
          </h4>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">5.</span>Number of <strong class="text-underline">Full Time</strong> Professionals (earning more than $20,000):
          </label>
          <input
            type="text"
            name="numberOfFullTimeProfessionals"
            v-model="groupAppraiser.numberOfFullTimeProfessionals"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('numberOfFullTimeProfessionals')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfFullTimeProfessionals') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">6.</span>Number of <strong class="text-underline">Part Time</strong> Professionals (earning less than $20,000):
          </label>
          <input
            type="text"
            name="numberOfPartTimeProfessionals"
            v-model="groupAppraiser.numberOfPartTimeProfessionals"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('numberOfPartTimeProfessionals')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfPartTimeProfessionals') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">7.</span>Number of Support Staff
          </label>
          <input
            type="text"
            name="numberOfSupportStaff"
            v-model="groupAppraiser.numberOfSupportStaff"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('numberOfSupportStaff')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfSupportStaff') | filterText }}</span>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 3: UNDERWRITING INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="mr-1">8.</span>
                Do at least 15% of all professionals hold a professional designation? (i.e. GRI, CRS, CRE, ABR, MAI, SRA)
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="holdAtLeast15PercentOfAllProfessionals"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.holdAtLeast15PercentOfAllProfessionals"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="holdAtLeast15PercentOfAllProfessionals"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.holdAtLeast15PercentOfAllProfessionals"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('holdAtLeast15PercentOfAllProfessionals')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('holdAtLeast15PercentOfAllProfessionals') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="mr-1">9.</span>
                Does Applicant control, own, or engage in any other business?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlInOtherBusiness"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.doesApplicantControlInOtherBusiness"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlInOtherBusiness"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.doesApplicantControlInOtherBusiness"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesApplicantControlInOtherBusiness')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesApplicantControlInOtherBusiness') | filterText }}</span>
            </div>
          </div>
          <input
            type="text"
            placeholder="Please explain:"
            class="orep-text-input js-orep-input"
            v-if="groupAppraiser.doesApplicantControlInOtherBusiness == true || groupAppraiser.doesApplicantControlInOtherBusiness === 'true'"
            name="doesApplicantControlInOtherBusinessDetails"
            v-model="groupAppraiser.doesApplicantControlInOtherBusinessDetails"
          >
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="mr-1">10.</span>
                Is Applicant controlled, owned, or managed by any other person, partnership, or corporation?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isApplicantControlledByOtherPerson"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.isApplicantControlledByOtherPerson"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isApplicantControlledByOtherPerson"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.isApplicantControlledByOtherPerson"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('isApplicantControlledByOtherPerson')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('isApplicantControlledByOtherPerson') | filterText }}</span>
            </div>
          </div>
          <input
            type="text"
            placeholder="Please explain:"
            class="orep-text-input js-orep-input"
            v-if="groupAppraiser.isApplicantControlledByOtherPerson == true || groupAppraiser.isApplicantControlledByOtherPerson === 'true'"
            name="isApplicantControlledByOtherPersonDetails"
            v-model="groupAppraiser.isApplicantControlledByOtherPersonDetails"
          >
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('group-appraiser-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('group-appraiser-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('group-appraiser-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('group-appraiser-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "group-appraiser-1",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    groupAppraiser() {
      return this.$store.state.groupAppraiser.groupAppraiser;
    },
    state() {
      return this.$store.state.groupAppraiser;
    },
    errorMsg() {
      return this.$store.state.groupAppraiser.errorMsg;
    }
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.groupAppraiser.customer.contactName = this.state.groupAppraiser.nameOfPrimaryLicensed;
      this.groupAppraiser.customer.companyName = this.state.groupAppraiser.nameOfApplicant;
      this.groupAppraiser.customer.isGroupAppraiser = 'True';
      this.groupAppraiser.customer.appStatus = APP_STATUS.Partially_Completed;
      this.$store.dispatch('groupAppraiser/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.groupAppraiser.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
